import { render, staticRenderFns } from "./proven-efficacy.vue?vue&type=template&id=05716402"
import script from "./proven-efficacy.vue?vue&type=script&lang=js"
export * from "./proven-efficacy.vue?vue&type=script&lang=js"
import style0 from "./proven-efficacy.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports